angular.module('lf.common')

.controller('SubscriptionPaymentCtrl', function ($scope, subscriptionService, helpers, gtmService) {
  
  // DEBUG
  var dummyCardForm = (function () {
    var client = lf.data.xhr.client;
    var isDesktop = client.isDesktop || client.isLFC;
    
    var dummy = {
      name: 'Jack Mao',
      number: '4444444444444448',
      cvn: '123',
      billingAddress: {
        address1: '1 Loop st',
        city: 'San Diego',
        postalCode: '11111',
        phoneNumber: '650 555-4433'
      },
      agree: true
    }
    
    if (isDesktop) {
      return $.extend(true, dummy, {
        "expires": {
          "month": "12",
          "year": "2015"
        },
        "billingAddress": {
          "state": "CA"
        }
      });
    } else if (client.isMobile) {
      return $.extend(true, dummy, {
        "expires": {
          "month": {
            "value": '06',
            "content": "06 - June"
          },
          "year": {
            "value": '2020',
            "content": "2020"
          }
        },
        "billingAddress": {
          "state": {
            "value": "CA",
            "content": "California"
          }
        }
      });
    }
  })();

  $scope.cardForm = {};
  $scope.formData = {
    months: helpers.creditCardForm.getMonths().slice(),
    years: helpers.creditCardForm.getYears().slice().map(function (year) {
      year.value = String(year.value);
      return year;
    }),
    states: helpers.getStates().slice()
  };

  $scope.addOrUpdateCard = function () {
    $scope.processing = true;
    $scope.showProcessingPopup();
    
    $scope.error = null;

    subscriptionService.addOrUpdateCard($scope.cardForm)
      .then(function (data) {
        if (data.success) {
          $scope.error = null;
          gtmService.subscription.payment.trackSuccessfulFormSubmission();
          setTimeout(function () {
            window.location = lf.data.xhr.siteBaseUrl + '/subscription/confirmation.jsp';
          }, 500);
          console.log('SubscriptionPaymentCtrl addOrUpdateCard success: true', data);
          // do redirect to the welcome page;
          // window.location = 'welcome.jsp';
        } else {
          console.log('SubscriptionPaymentCtrl addOrUpdateCard success: false', data);
          // handle success false
        }
      })
      .catch(function (error) {
        console.log('SubscriptionPaymentCtrl.addOrUpdateCard', error);
        $scope.error = {};
        if (error.details && error.details.length) {
          $scope.error.message = error.details[0];
        } else {
          $scope.error.serverError = true;
        }
        gtmService.subscription.payment.trackUnsuccessfulFormSubmission({
          'dimension5': $scope.error.message ? ('Server response: ' + $scope.error.message) : 'Server error'
        });
      })
      .finally(function (data) {
        $scope.processing = false;
        $scope.hideProcessingPopup();
      });
  }
  
  $scope.onFormError = function onFormError ($error) {
    if (!$error) return;
    var keys = _.keys($error);
    var errorSections = {};
    var billingInfoFields = ['number', 'name', 'ccExpMonth', 'ccExpYear', 'cvc'];
    var billingAddressFields = ['address1', 'address2', 'address3', 'city', 'state', 'postalCode', 'phone-number'];
    
    _.each(keys, function (key) {
      _.each($error[key], function (model) {
        var name = model.$name || '';
        if (billingInfoFields.indexOf(name) > -1) {
          errorSections['Information'] = true;
        }
        if (billingAddressFields.indexOf(name) > -1) {
          errorSections['Address'] = true;
        }
        if (name === 'agree') {
          errorSections['I agree'] = true;
        }
      });
    });
    
    _.each(_.keys(errorSections), function (section) {
      gtmService.subscription.payment.trackUnsuccessfulFormSubmission({
        'dimension5': section
      });
    });
  }
  
  $scope.fillCardFormWithDummyData = function () {
    $scope.cardForm = $.extend(true, {}, dummyCardForm);
  }
  
  $scope.resetCardForm = function () {
    $scope.cardForm = {};
  }
  
});

